import React from 'react';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import MockCredentialsHelper from './components/MockCredentialsHelper';
import SecurityBadges from './components/SecurityBadges';

const Login = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted/30 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Card Container */}
        <div className="bg-card border border-border rounded-2xl shadow-lg p-8 card-shadow">
          {/* Header Section */}
          <LoginHeader />

          {/* Login Form */}
          <LoginForm />

          {/* Demo Credentials Helper */}
          <MockCredentialsHelper />

          {/* Security Badges */}
          <SecurityBadges />
        </div>

        {/* Footer */}
        <div className="mt-6 text-center">
          <p className="text-xs text-muted-foreground">
            © 2025 Ecomotech. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;

